import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";

// Note: Update these paths to your actual avocado-related assets
import avocadoImage1 from "../../assets/banner1.jpg"; 
import avocadoImage2 from "../../assets/banner4.jpg"; 
import avocadoImage3 from "../../assets/banner6.jpg"; 

export default function ServiceAvocados() {
  return (
    <>
      <ServiceDetailPage
        label="Premium Export"
        title="Avocado Sourcing & Distribution"
        subtitle="Grade-A Hass and Fuerte avocados, ethically grown and precision-packed for the international market."
        overview="Tanzania's ideal climate produces some of the world's finest avocados. Our distribution network manages the entire supply chain—from partner orchards in the Southern Highlands to global ports—ensuring optimal ripeness, oil content, and skin quality through rigorous post-harvest management."
        images={[
          {
            src: avocadoImage1,
            alt: "Tanzanian avocado orchard",
            captionTitle: "Sustainable Cultivation",
            captionText: "Sourced from GAP-certified farms using sustainable irrigation and pest management.",
          },
          {
            src: avocadoImage2,
            alt: "Automated avocado sorting",
            captionTitle: "Precision Grading",
            captionText: "Automated weight and quality sorting to meet specific size and blemish-free requirements.",
          },
          {
            src: avocadoImage3,
            alt: "Avocado export crates",
            captionTitle: "Controlled Atmosphere Logistics",
            captionText: "Advanced Reefer containers ensure fruit arrives at the perfect stage of maturity.",
          },
        ]}
        highlights={[
          "Premium Hass and Fuerte varieties with high dry matter and oil content.",
          "GlobalG.A.P. and SMETA compliant sourcing for ethical assurance.",
          "Strict cold-chain management (5-7°C) from farm gate to destination.",
          "Customizable packaging solutions including cartons, punnets, and bulk bins.",
        ]}
        metrics={[
          { value: "Grade A", label: "Export Quality Standard" },
          { value: "0% Waste", label: "Sustainable Post-Harvest Goal" },
          { value: "Worldwide", label: "Air & Sea Freight Ready" },
        ]}
      />
      <Footer />
    </>
  );
}